<template>
  <TemplateTwoColPage
    :breadcrumbs="breadcrumbs"
    class="group-accred-page"
    :class="{'is-open': showCards}"
    :current-block.sync="currentBlock"
    data-qa="group-accred-page"
    :is-one-column="true"
    :loading="!item"
    :mini.sync="showCards">
    <template #left-content>
      <div class="group-accred-page__content">
        <GroupOfAccreditationFilesUpload
          v-if="createdGroups"
          :completed.sync="filesUploadCompleted"
          :files="newFiles"
          :group-value="item"
          :groups="createdGroups">
          <div
            slot="title"
            class="group-accred-page__content-title">
            {{ $t('groupOfAccreditation.filesUploadTitle') }}
          </div>
        </GroupOfAccreditationFilesUpload>
        <sForm
          v-else
          id="content-container"
          ref="groupAccredForm"
          data-qa="form-group-accred"
          :disabled="loading"
          label-position="top"
          label-width="100px"
          :model="item"
          :rules="rules">
          <GroupOfAccreditationStepInfo
            data-qa="step-info-block"
            :disabled="saveChanges"
            :item.sync="item"
            :loading="loading">
            <div
              slot="title"
              class="group-accred-page__content-title">
              {{ $t('groupOfAccreditation.ProvideInformationAboutGroup') }}
            </div>
          </GroupOfAccreditationStepInfo>
        </sForm>
      </div>
    </template>
    <template #left-footer>
      <CreateItemFooter
        v-if="createdGroups"
        key="files-upload-footer"
        :options="{
          back: {
            show: false,
          },
          steps: {
            show: false,
          },
          next: {
            show: true,
            disabled: !filesUploadCompleted,
            loading: false,
            label: $t('Common.Close'),
          },
        }"
        @next-step="submitExit"/>
      <CreateItemFooter
        v-else
        key="form-footer"
        :options="{
          steps: {
            show: false,
          },
          next: {
            show: true,
            disabled: !!loading || saveChanges,
            loading: !!saveChanges,
            label: itemId ? $t('Common.Save') : $t('Common.Create'),
          },
        }"
        @back-step="goTo"
        @next-step="saveChange"/>
    </template>
  </templatetwocolpage>
</template>
<script>
import TemplateTwoColPage from 'components/templates/TemplateTwoColPage.vue'
import CreateItemFooter from 'components/common/CreateItemFooter.vue'
import GroupOfAccreditationStepInfo from 'components/group of accreditations/create_edit/GroupOfAccreditationStepInfo.vue'
import GroupOfAccreditationFilesUpload from 'components/group of accreditations/create_edit/GroupOfAccreditationFilesUpload.vue'

import GroupOfAccreditationsApi from '@/api/groupOfAccreditationsApi'
const api = new GroupOfAccreditationsApi()

import { StorageFile } from '@/types/commonFile.js'
import { mapGetters } from 'vuex'

export default {
  name: 'groupOfAccreditationCreateEdit',
  data() {
    const that = this
    return {
      loading: true,
      saveChanges: false,
      item: {},
      // Групи, створені для декількох організацій (крок завантаження файлів): [{ id, organizationId }]
      createdGroups: null,
      filesUploadCompleted: false,
      showCards: true,
      currentBlock: {},
      rules: {
        title: [
          {
            type: 'string',
            trigger: 'change',
            transform(value) {
              return value.trim()
            },
            required: true,
            min: 2,
            message: this.$t('Validate.minLength', {number: 2, type: this.$tc('Common.characters', 2) })
          },
          {
            type: 'string',
            required: true,
            trigger: 'change',
            transform(value) {
              return value.trim()
            },
            max: 254,
            message: that.$t('Validate.maxLength', {number: 254, type: that.$tc('Common.characters', 254) })
          }
        ],
        description: [
          {
            type: 'string',
            trigger: 'change',
            transform(value) {
              return value.trim()
            },
            max: 4000,
            message: this.$t('Validate.maxLength', {number: 4000, type: this.$tc('Common.characters', 4000) })
          },
        ],
        categories: [
          {
            type: 'array',
            required: true,
            min: 1,
            message: this.$t('Common.ChooseValue', {number: 1, type: this.$tc('Tenders.Categories', 1) }),
            trigger: 'change'
          }
        ],
        // Поле з'являється на формі лише коли доступно більше однієї організації (див. GroupOfAccreditationStepInfo)
        organizationIds: [
          {
            type: 'array',
            required: true,
            min: 1,
            message: this.$t('Common.ChooseValue'),
            trigger: 'change'
          }
        ],
      }
    }
  },
  methods: {/**
     * Копирует группу по duplicate_id, очищая id и files
     */
    duplicateFromId(duplicateId) {
      this.loading = true
      api.getAccreditationGroupById(duplicateId)
        .then((response) => {
          if (!response) {
            this.$router.push({name: 'page-error', params: { status_code: 404, descript: 'GroupOfAccreditationItem not found'}})
            return
          }

          const { ...rest } = response
          this.item = {
            ...rest,
            files: [],
            organizationIds: this.defaultOrganizationIds,
            // Копія - нова чернетка: без статусу й дати публікації оригіналу, ознака тестової групи - лише якщо тест-мод доступний
            status: undefined,
            datePublish: undefined,
            isTest: this.$can('show', 'allowAccreditationTestGroups') && !!rest.isTest,
          }

          this.$router.replace({
            name: this.$route.name,
            params: this.$route.params,
            query: {}
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    
    async updateFiles(entityId) {
      // Удаление отмеченных deleted
      const deletePromises = this.item.files.filter(file => file.deleted && file.fileId)
        .map(async (file) => {
          try {
            await file.deleteFile()
            this.$emit('deletedFile', file)
          } catch (er) {
            //file.catchUploading(er)
            file.error = true
          }
        })

      const deleteResults = await Promise.allSettled(deletePromises)

      // Добавление новых файлов
      let addPromises = this.item.files.filter(file => !file.fileId).map(async (file) => {
        if (typeof file.updateEntityId === 'function') {
          file.updateEntityId(entityId)
        }
        return await file.uploadFile()
          .then(res => {
            if (res) {
              file.key = res
              file.fileId = res
              file.dateModified = new Date().toISOString()
              file.uri = `${window.config.GrapgQlUrl}/document/${res}`
              this.$emit('addedNewFile', file)
            } else {
              file.error = true
            }
          })
          .catch(() => {
            //file.catchUploading(er)
            file.error = true
          })
      })
      const addResults = await Promise.allSettled(addPromises)

      return [...deleteResults, ...addResults]
    },
    saveNewGroups(model) {
      return api.createAccreditationGroups({ ...model, organizationIds: this.item.organizationIds })
        .then((response) => {
          this.saveChanges = false
          if (!Array.isArray(response)) {
            return
          }
          if (!this.newFiles.length) {
            this.submitExit()
            return
          }
          // Групи вже створені - далі тільки крок завантаження файлів у кожну з них
          // (повторне "Створити" створило б дублікати груп)
          this.createdGroups = response
        })
    },
    saveGroup(model) {
      const apiModel = this.itemId ? api.updateAccreditationGroup(this.itemId, model) : api.createAccreditationGroup(model)

      return apiModel
        .then(async (response) => {
          if (!response) {
            return
          }
          const itemId = this.item.id = response.id || this.itemId
          const fileResults = await this.updateFiles(itemId)

          const hasFileErrors = Array.isArray(fileResults)
            ? fileResults.some(r => r.status === 'rejected')
            : false
          const hasFileObjErrors = (this.item.files || []).some(f => f.error) || false

          if (!hasFileErrors && !hasFileObjErrors) {
            this.$router.push({ name: 'groupOfAccreditationsItem', params: { id: itemId, org: this.$route.params.org } })
          } else {
            this.saveChanges = false
          }
        })
    },
    saveChange() {
      this.$refs.groupAccredForm.validate((valid) => {
        if (valid) {
          this.saveChanges = true
          const model = {
            title: this.item.title,
            description: this.item.description,
            categories: this.item.categories?.map(i => i.classificationCode) ?? [],
            requirements: this.item.requirements ?? [],
            isDocumentsSigningRequired: this.item.isDocumentsSigningRequired ?? false,
            isTest: !!this.item.isTest,
          }
          const saveRequest = this.isBatchCreate ? this.saveNewGroups(model) : this.saveGroup(model)

          saveRequest
            .catch(res => {
              this.saveChanges = false
              this.$log_error(res)
            })
        }
      })
    },
    submitExit() {
      this.$router.push({ name: 'groupOfAccreditationsList' , params: {org: this.$route.params.org} })
    },
    goTo() {
      this.submitExit()
    },

    getItem() {
      this.loading = true
      api.getAccreditationGroupById(this.itemId)
        .then((response) => {
          if (!response) {
            this.$router.push({name: 'page-error', params: { status_code: 404, descript: 'GroupOfAccreditationItem not found'}})
          }
          response.id = this.itemId
          response.files = (response.files || []).map(i => {
            i.entityId = this.itemId
            return new StorageFile(this.itemId, i, 'Accreditation')
          })
          this.item = response
        })
        .catch(res => this.$log_error(res))
        .finally(() => {
          this.loading = false
        })
    },
  },
  computed: {
    ...mapGetters({
      currentOrganization: 'getCurrentOrganization',
      availableOrganizations: 'getAvailableOrganizationsForCurrently',
    }),
    itemId() {
      return this.item?.id || this.$route.params?.id
    },
    newFiles() {
      return (this.item?.files || []).filter(file => !file.fileId && !file.deleted).map(file => file.file)
    },
    /**
     * Ключ поточної організації в активному просторі id (див. accreditationOrganizationIdMixin).
     * Прапор ON: внутрішній organizationId - з поточної організації або з доступних за збігом organizationItId
     * (список підвантажується асинхронно); на organizationItId не відкочуємось, щоб не змішувати простори id.
     */
    currentOrganizationId() {
      if (!this.growthBook?.accreditationGroupsInternalOrganizationId) {
        return this.currentOrganization?.organizationItId
      }
      const itId = this.currentOrganization?.organizationItId
      return this.currentOrganization?.organizationId
        ?? (this.availableOrganizations || []).find(organization => organization.organizationItId === itId)?.organizationId
    },
    defaultOrganizationIds() {
      return this.currentOrganizationId ? [this.currentOrganizationId] : []
    },
    /**
     * Групове створення (окремий ендпоінт) - якщо серед вибраних є не поточна організація.
     * Вибрана тільки поточна (або селект прихований, бо доступна одна організація) - звичайне створення однієї групи.
     */
    isBatchCreate() {
      return !this.itemId && (this.item?.organizationIds || []).some(id => id !== this.currentOrganizationId)
    },
    breadcrumbs() {
      return [
        {
          text: this.$t('Menu.GroupOfAccreditations'),
          action: this.goTo
        },
        {
          text: this.itemId
            ? this.item?.title || ('#' + this.itemId)
            : this.$t('groupOfAccreditation.newGroup'),
        },
      ]
    },
  },
  watch: {
    // Доступні організації завантажуються асинхронно: дозаповнюємо порожній дефолт нової групи, коли id поточної з'явився
    currentOrganizationId() {
      if (!this.itemId && Array.isArray(this.item?.organizationIds) && !this.item.organizationIds.length) {
        this.$set(this.item, 'organizationIds', this.defaultOrganizationIds)
      }
    },
  },
  components: {
    CreateItemFooter,
    TemplateTwoColPage,
    GroupOfAccreditationStepInfo,
    GroupOfAccreditationFilesUpload,
  },
  created() {
    // Копирование по duplicate_id
    if (this.$route?.query?.duplicate) {
      this.duplicateFromId(this.$route?.query?.duplicate)
      return
    }
    // Обычное редактирование
    if (this.itemId) {
      if (this.$route.name !== 'groupOfAccreditationEdit') {
        this.$router.replace({name: 'groupOfAccreditationEdit', query: {...this.$route.query, id: this.itemId }}, () => {}, () => {}, { force: true })
      }
      this.getItem()
    } else if (this.$route.name !== 'groupOfAccreditationNew') {
      this.$router.push({ name: 'groupOfAccreditationNew', params: {org: this.$route.params.org}})
      //this.hash = this.$_hashCode(this.item)
    } else {
      this.loading = false
      this.item = {
        title: '',
        description: '',
        categories: [],
        files: [],
        isDocumentsSigningRequired: true,
        isTest: false,
        organizationIds: this.defaultOrganizationIds,
      }
    }
  },
  props: {},
}
</script>
<style scoped lang="scss">
.group-accred-page {
  &__content {
    padding-top: 10px;
    grid-column: span 2;
    text-align: left;
    padding-left: 30px;
    padding-right: 30px;
    margin-bottom: 20px;
    &-title {
      font-size: 32px;
      font-weight: 600;
      line-height: 36px;
      text-align: left;
      margin-bottom: 24px;
    }
  }
}

</style>
